import { render, staticRenderFns } from "./host-set-businessType.vue?vue&type=template&id=7235f86a&scoped=true&"
import script from "./host-set-businessType.vue?vue&type=script&lang=js&"
export * from "./host-set-businessType.vue?vue&type=script&lang=js&"
import style0 from "./host-set-businessType.vue?vue&type=style&index=0&id=7235f86a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235f86a",
  null
  
)

export default component.exports